export type TestFillTranslation = {
  backToCertification: string;
  finish: string;
  finishDialog: {
    cancel: string;
    confirm: string;
    content: string;
    title: string;
  };
  label: string;
  next: string;
  notFound: string;
  previous: string;
  progressLabel: string;
  questionCounter: string;
  questionLabel: string;
  rankInstruction: string;
  result: {
    backToCertification: string;
    correctRanking: string;
    expiredDescription: string;
    failed: string;
    noAnswer: string;
    passed: string;
    questionsAccessExpired: string;
    questionsAvailableAfterTerm: string;
    questionsAvailableWindowInfo: string;
    questionsRemainingTime: string;
    questionsTitle: string;
    score: string;
    threshold: string;
    title: string;
    yourAnswer: string;
    yourRanking: string;
  };
  section: string;
  submitting: string;
  timeExpired: string;
  timeLeft: string;
  unavailable: {
    backToCertification: string;
    cancelledDescription: string;
    completedDescription: string;
    genericDescription: string;
    newDescription: string;
    title: string;
  };
};

export const testFillTranslation: TestFillTranslation = {
  backToCertification: 'Back to Certification',
  finish: 'Finish',
  finishDialog: {
    cancel: 'Cancel',
    confirm: 'Finish test',
    content:
      'Are you sure you want to finish the test? After confirming, you will not be able to return to edit your previous answers.',
    title: 'Finish the test?',
  },
  label: 'Test',
  next: 'Next',
  notFound: 'Test not found',
  previous: 'Previous',
  progressLabel: 'Progress',
  questionCounter: 'Question {{current}} of {{total}}',
  questionLabel: 'Question {{number}}',
  rankInstruction: 'Drag the items to arrange them in the correct order',
  result: {
    backToCertification: 'Back to Certification',
    correctRanking: 'Correct order',
    expiredDescription:
      'The time for completing the test has ended. The test was finished automatically.',
    failed: 'Failed',
    noAnswer: 'No answer',
    passed: 'Passed',
    questionsAccessExpired: 'Question access time has expired.',
    questionsAvailableAfterTerm:
      'Question details will be available after the term automatically ends at {{termEndDatetime}} or immediately after the exam supervisor manually closes the term.',
    questionsAvailableWindowInfo:
      'Questions will be available for only {{minutes}} min after the term ends.',
    questionsRemainingTime: 'Questions available for: {{time}}',
    questionsTitle: 'Question details',
    score: 'Your score: {{score}}%',
    threshold: 'Passing threshold: {{threshold}}%',
    title: 'Test result',
    yourAnswer: 'Your answer',
    yourRanking: 'Your order',
  },
  section: 'Section: {{name}}',
  submitting: 'Saving...',
  timeExpired: 'Time has expired',
  timeLeft: 'Time left: {{time}}',
  unavailable: {
    backToCertification: 'Back to Certification',
    cancelledDescription:
      'This test term has been cancelled. You cannot continue solving the test.',
    completedDescription: 'This test term has been completed. You cannot submit further answers.',
    genericDescription:
      'This test term is currently unavailable. Please contact your administrator.',
    newDescription: 'This test term has not started yet. Please come back when it is open.',
    title: 'Test term unavailable',
  },
};
